// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging, onMessage, getToken } from "firebase/messaging";

import song from "../assets/CoinDrop-Notification.mp3"

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC5fNC_9DohRSi6JPj_Yk30GzxqfMWHVyM",
  authDomain: "cloudkitchen-id.firebaseapp.com",
  projectId: "cloudkitchen-id",
  storageBucket: "cloudkitchen-id.appspot.com",
  messagingSenderId: "914386146166",
  appId: "1:914386146166:web:3776dd19983a87abd92057",
  measurementId: "G-QZ24DEYY9E",
  token_option: "BGWML-shQCslDxbUOsSu0unDGxRlden37lEYx9SVwhocn0v9bMU0PXQcvKffikJw0cLRIvf14ftg_MLuxMsoKrM", // your vapid key

};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app)
const storage = getStorage(app);
const configMessage = getMessaging(app);
auth.languageCode = 'id';

export {app,analytics,auth,db}
export const fetchToken = async (setTokenId) => {
  try {
    const token = await getToken(configMessage, { vapidKey: firebaseConfig.token_option });
    if (token) {
      // console.log(token, "this is push notif token");
      setTokenId(token);
    } else {
      console.log("no push notif token for now");
    }
  } catch (error) {}
};

export const onMessageListener = (toast) => {
	onMessage(configMessage, (payload) => {
		const notif = new Audio(song)
		notif.play();
		const { data } = payload
		const { title, description } = data
		toast({
			title: title,
			description: description,
			position: 'top-right',
			isClosable: true,
		})
	});
};